import React from 'react';
import { Card, Col, Input, Row, Select, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { ApplicationDocumentFilterDraft, ApplicationDocumentSource } from '../../utils/applicationDocumentRegistry';
import { DOCUMENT_REGISTRY_CATEGORY_OPTIONS } from '../../utils/documentRegistryUi';
import type { Route } from '../../types';

const { Text } = Typography;

const SOURCE_OPTIONS: { value: ApplicationDocumentSource | 'all'; label: string }[] = [
  { value: 'all', label: 'Все' },
  { value: 'Заявка', label: 'Заявка' },
  { value: 'Маршрут', label: 'Маршрут' },
  { value: 'Погрузка', label: 'Погрузка' },
  { value: 'Выгрузка', label: 'Выгрузка' },
];

type ApplicationDocumentFiltersProps = {
  filters: ApplicationDocumentFilterDraft;
  routes: Route[];
  stopOptions: string[];
  onChange: (next: ApplicationDocumentFilterDraft) => void;
};

const ApplicationDocumentFilters: React.FC<ApplicationDocumentFiltersProps> = ({
  filters,
  routes,
  stopOptions,
  onChange,
}) => (
  <Card size="small" style={{ marginBottom: 16 }}>
    <Row gutter={[12, 12]}>
      <Col xs={24} md={8} lg={6}>
        <Text type="secondary">Источник</Text>
        <Select
          style={{ width: '100%' }}
          value={filters.source ?? 'all'}
          onChange={(value) => onChange({ ...filters, source: value })}
          options={SOURCE_OPTIONS}
        />
      </Col>
      <Col xs={24} md={8} lg={6}>
        <Text type="secondary">Тип документа</Text>
        <Select
          allowClear
          placeholder="Категория"
          style={{ width: '100%' }}
          value={filters.documentCategory}
          onChange={(value) => onChange({ ...filters, documentCategory: value })}
          options={[...DOCUMENT_REGISTRY_CATEGORY_OPTIONS]}
        />
      </Col>
      <Col xs={24} md={8} lg={6}>
        <Text type="secondary">Маршрут</Text>
        <Select
          allowClear
          placeholder="Все маршруты"
          style={{ width: '100%' }}
          value={filters.routeId}
          onChange={(value) => onChange({ ...filters, routeId: value, stopLabel: undefined })}
          options={routes.map((route) => ({
            value: route.id,
            label: `#${route.id}`,
          }))}
        />
      </Col>
      <Col xs={24} md={8} lg={6}>
        <Text type="secondary">Стоп</Text>
        <Select
          allowClear
          placeholder="Все стопы"
          style={{ width: '100%' }}
          value={filters.stopLabel}
          onChange={(value) => onChange({ ...filters, stopLabel: value })}
          options={stopOptions.map((label) => ({ value: label, label }))}
        />
      </Col>
      <Col xs={24} md={12} lg={8}>
        <Text type="secondary">Поиск</Text>
        <Input
          allowClear
          placeholder="Название, тип, комментарий..."
          prefix={<SearchOutlined />}
          value={filters.search || ''}
          onChange={(e) => onChange({ ...filters, search: e.target.value || undefined })}
        />
      </Col>
    </Row>
  </Card>
);

export default ApplicationDocumentFilters;
